/* eslint-disable react/react-in-jsx-scope */
import { handleEvent, handleBtnValue } from '../../utils/events'

const transformer = function (origin, defs, rowData, events, hooks) {
  // events 是对定制项目的自定义事件
  const ret = {
    render: 'text',
    origin,
  }

  const params = {
    rowData,
    hooks,
    opts: {
      slug: defs.slug,
    },
  }
  const btnValue = handleBtnValue(origin, defs, params)
  const { handleData, style } = btnValue || {}
  const showData = handleData ? handleData(rowData) : null

  const onClickBtn = () => {
    handleEvent(origin, defs, params, events, rowData)
  }

  ret.value = { text: showData || btnValue.title, style }
  ret.onClick = onClickBtn
  // <div className="cursor-pointer w-full">
  //   <div
  //     onClick={(e) => {
  //       onClickBtn()
  //       e.stopPropagation()
  //     }}
  //   >
  //     <div style={style}>{showData || btnValue.title}</div>
  //   </div>
  // </div>

  return ret
}

export default transformer
